import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface IWebsiteContentAlertsFilterState {
    searchValue: string;
}

interface IWebsiteContentAlertsFilterStore extends IWebsiteContentAlertsFilterState {
    reset: () => void;
    setSearchValue: (value: string) => void;
}

const initialState: IWebsiteContentAlertsFilterState = {
    searchValue: "",
};

export const useWebsiteContentAlertsFilterStore = create<IWebsiteContentAlertsFilterStore>()(
    devtools(
        (set) => ({
            ...initialState,
            reset: () => set(initialState),
            setSearchValue: (value) => set({ searchValue: value }),
        }),
        { name: "WebsiteContentAlertsFilterStore" },
    ),
);
